import { Injectable } from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {WrapperService} from '../wrapper/wrapper.service';
import {Observable} from 'rxjs';
import {EndPoints} from '../../constants/endpoints';
import {TaskDTO} from '../../models/TaskDTO';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private _api: WrapperService) { }

  get(expirationDate?: string): Observable<any> {
    // Sin fecha (undefined, null o '') se pide el listado completo, sin ningún parámetro de query
    if (expirationDate) {
      // La fecha viaja tal cual (YYYY-MM-DD): sin conversión de zona horaria
      const params = new HttpParams().set('expiration_date', expirationDate);
      return this._api.get(EndPoints.TASK, params);
    }
    return this._api.get(EndPoints.TASK);
  }

  create(task: Object): Observable<any> {
    return this._api.post(EndPoints.TASK, task);
  }

  update(id: number, task: Object): Observable<any> {
    return this._api.put(EndPoints.TASK + '/' + id, task);
  }

  delete(task: TaskDTO) {
    return this._api.delete(`${EndPoints.TASK}/${task.id}`);
  }

  commit(task: Object): Observable<any> {
    return this._api.post(EndPoints.TASK+ '/commit', task);
  }

  uploadFiles(body: Object): Observable<any> {
    return this._api.post(EndPoints.TASK_UPLOAD_FILES, body);
  }

  getcommits(id:number){
    return this._api.get(EndPoints.TASK+'/getcommits/'+id);
  }
}
